import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

interface OptionItem {
  value: string;
  label: string;
  icon: string;
}

@Component({
  selector: 'app-option-button-group',
  templateUrl: './option-button-group.component.html',
  imports: [TranslateModule],
})
export class OptionButtonGroupComponent {
  @Input() options: OptionItem[] = [
    { value: 'individual', label: 'payment_flow.Individual', icon: 'user' },
    { value: 'organization', label: 'Organization', icon: 'building' },
  ];
  @Input() control: any;
  @Input() label: string = '';
  @Input() errorMessage: string = 'Please select an option';
}
